import { apiRequestFactory } from "@/api/util";

const apiSpec = {
  "/user/group/search/global": {
    required: [],
    listResponse: "groups",
  },
};

const apiRequest = apiRequestFactory(apiSpec);

export default {
  global: (options, args) => apiRequest(options, "/user/group/search/global", args),
};
